import { Platform } from 'react-native';

import { getAttributionForSubmit } from '@/lib/attribution';

/**
 * Origem da primeira visita + onde a conta nasceu (`web`, `ios`, `android`).
 * Fica fora de `attribution.ts` porque aquele módulo roda nos testes em Node,
 * sem `react-native`.
 */
export function getSignupAttribution() {
  return {
    ...getAttributionForSubmit(),
    signupPlatform: Platform.OS === 'ios' || Platform.OS === 'android' ? Platform.OS : 'web',
  };
}
